<div class="add-edit-role-modal-block">
  <div class="uitk-l-grid__row">
    <div class="uitk-l-grid__col--12 ps-0 pe-0">
      <div class="role-management-fields">
        <div class="row">
          @if (actionType == 'Add') {
          <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
            <label>{{ forecastRolePlaceholder }}</label>
            <app-dropdown-with-search
              [Pixeltracking]="'false'"
              [showPlaceholder]="'false'"
              searchFlag="true"
              isMultiSelect="false"
              [dropdownData]="forecastRoleList"
              [selected]="selectedRole"
              (selectionChange)="setSelectedRoleValue($event)"
            ></app-dropdown-with-search>
          </div>
          } @if (actionType == 'Edit') {
          <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
            <div class="ms-2">
              <label>Forecast Role</label>
              <p>{{ selectedRole?.name }}</p>
            </div>
          </div>
          } @if (selectedRole && actionType == 'Add') {
          <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
            <label>{{ segmentPlaceholder }}</label>
            <app-dropdown-with-search
              [Pixeltracking]="false"
              [showPlaceholder]="'false'"
              searchFlag="true"
              [disableDD]="disableDD"
              isMultiSelect="true"
              [dropdownData]="segmentArray"
              [selected]="selectedSegmentArr"
              (selectionChange)="setSelectedSegmentArr($event)"
            ></app-dropdown-with-search>
          </div>
          } @if (selectedRole && actionType == 'Edit') {
          <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
            <div class="ms-2">
              <label>Segment</label>
              <p>{{ editData.Master_Segment }}</p>
            </div>
          </div>
          } @if (selectedSegmentArr?.length > 0) {
          <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
            <div class="add-section">
              <div class="form-group w-40">
                <label>{{ userPlaceholder }}</label>
                <mat-form-field
                  [disableRipple]="true"
                  appearance="outline"
                  class="inline-form-edit chip-select-stakeholder select-user-dropdown"
                  floatLabel="never"
                >
                  <mat-chip-grid #chipList>
                    <!-- <ng-container *ngIf="selectedUser">
                      <mat-chip-row class="stk-mat-chip" (removed)="removeSelectedUser()">
                        {{selectedUser.givenName}} {{selectedUser.sn}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip-row>
                    </ng-container> -->
                  </mat-chip-grid>
                  <input
                    placeholder="Search by Name/Mail (min 4 chars)"
                    matInput
                    [matAutocomplete]="auto"
                    (keyup)="onSearchUser($event)"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  />
                  <mat-autocomplete
                    showPanel="true"
                    class="lob-options-list"
                    #auto="matAutocomplete"
                    (optionSelected)="getSelectedUsers($event)"
                  >
                    @for (user of searchUserList; track user) {
                    <mat-option
                      [disabled]="user?.disable"
                      title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})"
                      [value]="user"
                    >
                      {{ user.MSId || user.msid }}<{{ user.displayName }}>({{ user.mail }})
                    </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </div>
          }
        </div>
        @if (selectedSegmentArr?.length > 0 || actionType == 'Edit') {
        <div class="row select-section">
          <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4"></div>
          <div class=" col-md-8 col-sm-8 col-lg-8 col-xl-8 col-xs-8">
            <div class="action-button-section">
              @if (dataSourceDetails?.data.length > 0) {
              <button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                mat-mdc-raised-button
                (click)="onRemoveUser()"
                [disabled]="selectedRemoveUserlist?.length == 0"
              >
                Remove User
              </button>
              }
            </div>
          </div>
        </div>
        }
      </div>
      @if (selectedSegmentArr?.length > 0 || actionType == 'Edit') { @if (actionType == 'Edit' || (actionType == 'Add'
      && dataSourceDetails && dataSourceDetails?.data?.length > 0)) {
      <div class="table-block">
        @if (selectedSegmentArr?.length > 0) {
        <app-maintenance-table-v4
          [TABLE_CONFIG]="TABLE_CONFIG"
          [COLUMNS]="TABLE_COLUMNS"
          [SORT_CONFIG]="sortConfig"
          [dataSource]="dataSourceDetails"
          [SCHEMA]="DATA_SCHEMA"
          [pageSize]="TABLE_CONFIG.pageSize"
          [isTableRefreshed]="isTableRefreshed"
          [pageIndex]="TABLE_CONFIG.pageIndex"
          (checkBoxEvent)="checkboxClick($event)"
          [pageSizeOptions]="[5, 10, 15]"
          [noRowHeight]="true"
        >
        </app-maintenance-table-v4>
        }
      </div>
      } @if (dataSourceDetails?.data.length > 0 || actionType == 'Edit') {
      <div class="button-block mt-3">
        <button
          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
          mat-mdc-raised-button
          (click)="onSubmitForm()"
          [disabled]="isSubmitButtonDisabled"
        >
          Submit
        </button>
      </div>
      } }
    </div>
  </div>
</div>
@if (showLoader) {
<div class="stk-table-loader loader-position">
  <app-loader></app-loader>
</div>
}
